/* eslint-disable @nx/enforce-module-boundaries */
import { MultiChoiceQuestionConfig } from '@hyper-inferno/multiple-choice-core';
import {
  QuestionHandler,
  ITransformationContext,
} from '@hyper-inferno/survey-bot-core';
import {
  QuestionAnswerObject,
  SurveyElement,
} from '@hyper-inferno/survey-elements-core';

export class MultipleChoiceHandler
  implements QuestionHandler<MultiChoiceQuestionConfig>
{
  async buildConfig(el: any, ctx: ITransformationContext) {
    const options = await ctx.listBuilding.getOptionsByListId(
      el.config.list_id,
      ctx,
      el.config.randomize_options,
    );

    return {
      ...el.config,
      options,
    };
  }

  getValue(el: SurveyElement, response: QuestionAnswerObject) {
    // Regex: Starts with el.name, followed by _, ends with one or more digits
    const pattern = new RegExp(`^${el.name}_\\d+$`);

    return Object.keys(response)
      .filter((key) => pattern.test(key))
      .map((key) => response[key] as number);
  }
}
